import "rxjs";
import { createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";

import { default as rootStore } from "./store";
import App from "./module/common/App";
import "./i18n";

import "./assets/scss/bundle.css";
import "@fontsource/inter";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import { QueryClient, QueryClientProvider } from "react-query";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";

TimeAgo.addLocale(en);

if (console && console.log) {
  console.log(
    `%cApp Version: ${process.env.REACT_APP_VERSION}`,
    "color: blue; font-size: 20px"
  );
}

export const queryClient = new QueryClient();
const container = document.getElementById("root");
const root = createRoot(container as HTMLElement);
root.render(
  <Provider store={rootStore}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
